import { useCurrentLessonContext } from "@circle-react/contexts/currentLessonContext";
import { useCurrentPostContext } from "@circle-react/contexts/currentPostContext";
import noop from "lodash/noop";
import { useEffect } from "react";

export const useFormSubmitDisabler = ({ isLoading }) => {
  const { setIsSubmitEnabled: setPostIsSubmitEnabled = noop } =
    useCurrentPostContext();
  const { setIsSubmitEnabled: setLessonIsSubmitEnabled = noop } =
    useCurrentLessonContext();

  useEffect(() => {
    setPostIsSubmitEnabled(!isLoading);
    setLessonIsSubmitEnabled(!isLoading);
  }, [isLoading, setPostIsSubmitEnabled, setLessonIsSubmitEnabled]);
};
